import React, { useState } from "react"
import { FiArchive, FiBell,  FiMenu,FiMoreVertical, FiTrash2, FiUser, FiUsers, FiVolumeX, FiX, FiCheckCircle, FiLayout,  FiPhone, FiSearch } from "react-icons/fi"
import clx from "classnames"
import { neonGroupMembers } from "../../../../dummy/mock"
import { Notifications } from "../../team/content/notifications"
import { useModal } from "../../../../stores/useModal"
import neonStore from "../../../../stores/useNeon"
import { useDrawer } from "../../../../stores/useDrawer"
import { Option } from "./option"

export const Header = ({
    profile,
    setProfile,
    menu,
    setMenu
}) => {
  const {detail, setDetail, search, setSearch } = neonStore(state=>state)
  const modal = useModal(state=>state)
  const drawer = useDrawer(state=>state)    
  const openDetail = () => drawer.open({type:'neon-detail'})
  const openMenu = () => drawer.open({type:'neon-menu'})

  const [show, setShow] = useState(false)
  const [phone, setPhone] = useState(false)

    return (
        <React.Fragment>
            <div
                    className="header backdrop-blur-md dark:bg-[#141618]/30 bg-gray-100/60 sticky 
                    top-0 z-30 -bg-[#141618] p-3 px-10 w-full flex-col sm:flex-row flex justify-between items-center"
                    >
                    <div className="font-medium cursor-pointer">Developer Sieges</div>
                    <div 
                      title="Group members"
                      className="flex items-center gap-2">
                        <div className="members hidden md:flex">
                        {neonGroupMembers.map((member,i)=>(
                            <img
                            key={`member-${i}`}
                            src={`/images/avatars/${member}`}
                            className="-ml-4 h-10 cursor-pointer border border-2 rounded-full"
                            />
                        ))}

                        
                        </div>

                        <div className="hidden relative cursor-pointer">
                        <FiBell size={23} className="h-5 text-gray-400"/>
                        </div>

                        <div
                        onClick={()=>setProfile(!profile)}
                        className={clx('hidden', profile ? 'text-blue-400' : 'text-gray-400' )}
                        >
                        <FiUser size={23} className="cursor-pointer"/>
                        </div>
                        
                        <Option />

                        <div
                        title="Toggle user profile"
                        onClick={()=>setProfile(!profile)}
                        className={clx(
                          profile ? 'bg-blue-200 dark:bg-blue-800' : 'bg-gray-200 dark:bg-zinc-800',
                          {'':!profile}, 'hidden md:flex items-center cursor-pointer pr-2 rounded-full p-1' )}
                        >
                            <img
                                src="/images/avatars/Vector-13.png"
                                className="w-6 h-6 rounded-full cursor-pointer"
                            />
                            <p className="text-gray-700 dark:text-zinc-300">@tester</p>
                        </div>

                        <Notifications />
                        
                        <div class="flex gap-4 items-center">
                        <div
                            class="cursor-pointer"
                          onClick={()=>setSearch(!search)}
                          className={clx(search?'text-blue-400':'text-gray-400')}
                          >
                          <FiSearch size={23} />
                          </div>
                      
                          <div
                          // onClick={()=>setPhone(!phone)}
                          onClick={()=>modal.open({type:'phone-call'})}
                          className={clx(phone?'text-blue-400':'text-gray-400')}
                          >
                            <FiPhone size={23} class="cursor-pointer" />
                          </div>

                          <div
                          onClick={()=>setDetail(!detail)}
                          className={clx(detail?'text-blue-400':'text-gray-400')}
                          >
                            <FiLayout size={23} class="cursor-pointer" />
                            </div>



                        <div className="darkmode">
                        <button
                            className="theme-toggle"
                            id="theme-toggle"
                            title="Toggles light & dark"
                            aria-label="auto"
                            aria-live="polite"
                        >
                            <svg
                            className="sun-and-moon"
                            aria-hidden="true"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            >
                            <mask className="moon" id="moon-mask">
                                <rect
                                x="0"
                                y="0"
                                width="100%"
                                height="100%"
                                fill="white"
                                />
                                <circle cx="24" cy="10" r="6" fill="black" />
                            </mask>
                            <circle
                                className="sun"
                                cx="12"
                                cy="12"
                                r="6"
                                mask="url(#moon-mask)"
                                fill="currentColor"
                            />
                            <g className="sun-beams" stroke="currentColor">
                                <line x1="12" y1="1" x2="12" y2="3" />
                                <line x1="12" y1="21" x2="12" y2="23" />
                                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                                <line x1="1" y1="12" x2="3" y2="12" />
                                <line x1="21" y1="12" x2="23" y2="12" />
                                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                            </g>
                            </svg>
                        </button>
                        </div>

                            {/*  OPTIONS COMPONENT */}
                            <div className="relative">
                            <div
                                onClick={()=>setShow(!show)}
                            >
                                <div className="">
                                <FiMoreVertical size={23}
                                    className="text-gray-400 cursor-pointer"
                                />
                                </div>
                                {show && (
                                    <div
                                    className=" dropdown absolute right-0 top-6 z-10 divide-y border 
                                    bg-white dark:bg-zinc-900 dark:text-white rounded-lg w-32 dark:border-zinc-700"
                                    >
                                    <ul className=" py-2 text-sm text-gray-200">
                                        {[
                                            {value:'Detail', icon:<FiUsers size={23} className="h-4 text-zinc-600" />},
                                            {value:'Archive', icon:<FiArchive size={23} className="h-4 text-zinc-600" />},
                                            {value:'Muted', icon:<FiVolumeX size={23} className="h-4 text-zinc-600" />},
                                            {value:'Delete', icon:<FiTrash2 size={23} className="h-4 text-zinc-600" />},
                                            {value:'Close   ', icon:<FiX size={23} className="h-4 text-zinc-600" />},
                                        ].map(item=>(
                                            <li
                                            className=" cursor-pointer"
                                            onClick={openDetail}
                                            >
                                            <div className="block text-zinc-500
                                            dark:hover:bg-zinc-800 dark:text-gray-400
                                            hover:bg-zinc-200 px-4 py-2 flex gap-1 items-center">
                                                {item.icon}
                                                <p>{item.value}</p>
                                            </div>
                                            </li>
                                        ))}
                                    
                                    </ul>
                                    </div>
                                )}
                            </div>
                        </div>


                        <div 
                        onClick={openMenu}
                        className="md:hidden"
                        >
                        <FiMenu size={23} className="text-gray-400 cursor-pointer"/>
                        </div>
                    </div>
               </div>
            </div>
        </React.Fragment>
    )
}

